const STORAGE_KEY = 'survey_access_codes_v1';

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

function sanitize(map) {
  const out = {};
  if (!map || typeof map !== 'object') return out;
  for (const [k, v] of Object.entries(map)) {
    if (typeof v !== 'string') continue;
    const trimmed = v.trim();
    if (!trimmed) continue;
    out[k] = trimmed;
  }
  return out;
}

export function loadAccessCodeState() {
  if (!isBrowser()) return { map: {}, enabled: false };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { map: {}, enabled: true };
    const parsed = JSON.parse(raw);
    return { map: sanitize(parsed), enabled: true };
  } catch (err) {
    return { map: {}, enabled: false };
  }
}

export function saveAccessCodeState(map) {
  if (!isBrowser()) return false;
  try {
    const sanitized = sanitize(map);
    const keys = Object.keys(sanitized);
    if (!keys.length) {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(sanitized));
    }
    return true;
  } catch (err) {
    return false;
  }
}

export function rememberAccessCode(surveyId, code) {
  if (!surveyId || !code) return false;
  const { map, enabled } = loadAccessCodeState();
  if (!enabled) return false;
  const next = { ...map, [String(surveyId)]: String(code).trim() };
  return saveAccessCodeState(next);
}

export function forgetAccessCode(surveyId) {
  if (!surveyId) return false;
  const { map, enabled } = loadAccessCodeState();
  if (!enabled) return false;
  const key = String(surveyId);
  if (!(key in map)) return true;
  const next = { ...map };
  delete next[key];
  return saveAccessCodeState(next);
}

export function readAccessCode(surveyId) {
  const key = String(surveyId);
  const { map } = loadAccessCodeState();
  return map[key] || '';
}
